import { render, staticRenderFns } from "./NewWineDialog.vue?vue&type=template&id=208c69f6&scoped=true"
import script from "./NewWineDialog.vue?vue&type=script&lang=js"
export * from "./NewWineDialog.vue?vue&type=script&lang=js"
import style0 from "./NewWineDialog.vue?vue&type=style&index=0&id=208c69f6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c69f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('208c69f6')) {
      api.createRecord('208c69f6', component.options)
    } else {
      api.reload('208c69f6', component.options)
    }
    module.hot.accept("./NewWineDialog.vue?vue&type=template&id=208c69f6&scoped=true", function () {
      api.rerender('208c69f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/NewWineDialog.vue"
export default component.exports